module.exports = __webpack_public_path__ + "static/media/post-06.82a7e4bf.png";